import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "quickform__container quickform--has-tabs quickform--has-offset" }
const _hoisted_2 = {
  key: 0,
  class: "quickform-tabs",
  role: "tablist"
}
const _hoisted_3 = { class: "quickform-tabs__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuickformForm = _resolveComponent("QuickformForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isExternal === false)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("li", { class: "quickform-tabs__item active" }, [
            _createElementVNode("a", {
              href: "#",
              role: "tab",
              "aria-controls": "travel"
            }, [
              _createElementVNode("span", { class: "quickform-tabs__text" }, "Travel")
            ])
          ], -1)),
          _createElementVNode("li", _hoisted_3, [
            _createElementVNode("a", {
              role: "tab",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleVideo && _ctx.toggleVideo(...args))),
              "aria-controls": "video-guide",
              href: "#"
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "quickform-tabs__text" }, "Isles of Scilly Travel: Video Guide", -1)
            ]))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["quickform", { 'external' : _ctx.isExternal }])
    }, [
      _createVNode(_component_QuickformForm, { isExternal: _ctx.isExternal }, null, 8, ["isExternal"])
    ], 2)
  ]))
}